import React from 'react';
import { biographyData } from '../data/mock';
import { Quote, Linkedin, Instagram } from 'lucide-react';

const socialLinks = [
  {
    id: 'linkedin',
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/ruben-wargner-59a83b336',
    Icon: Linkedin
  },
  {
    id: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/rubenwargner',
    Icon: Instagram
  }
];

const BiographySection = ({ section, index }) => {
  return (
    <div className="biography-section-item">
      <div className="bio-section-number">
        <span>0{index + 1}</span>
      </div>
      <div className="bio-section-content">
        <h3 className="heading-4">{section.title}</h3>
        <p className="body-medium">{section.content}</p>
        {section.quote && (
          <blockquote className="bio-quote">
            <Quote size={24} className="quote-mark" />
            <p>{section.quote}</p>
          </blockquote>
        )}
      </div>
    </div>
  );
};

const Biography = () => {
  return (
    <section id="biography" className="biography-section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Biography</span>
          <h2 className="heading-2">The Journey of a Visionary</h2>
          <div className="bio-social-links">
            {socialLinks.map(({ id, label, href, Icon }) => (
              <a
                key={id}
                href={href}
                className="bio-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${label} profile`}
              >
                <Icon size={22} />
                <span className="sr-only">{label}</span>
              </a>
            ))}
          </div>
        </div>
        
        <div className="biography-content">
          {biographyData.sections.map((section, index) => (
            <BiographySection key={index} section={section} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Biography;
